module.exports = __webpack_public_path__ + "img/MULTPEX_LOGO.2a710c2c.png";